import React from "react";
//import Row from "react-bootstrap/Row";
//import Col from "react-bootstrap/Col";

function MessageLog(props) {
    const messageList = [];
    for (const [index, value] of props.log.entries()) {
        const msg = "".concat("[",value.time,"] ",value.text)
        messageList.push(<div key={index}>{msg}</div>);
    }
    return (
        <div>
            <h2> Message Log: </h2>
            {messageList}
        </div>
    )
}

export default MessageLog;
